module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appProject"
    }
  }, [_c('com-loading'), _vm._v(" "), _c('com-progress'), _vm._v(" "), (_vm.currentStatus === 'preview') ? _c('com-header', {
    attrs: {
      "links": _vm.headerLinks,
      "title": _vm.getSelectProject.projectName
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStatus === 'preview') ? _c('div', {
    staticClass: "main preview"
  }, [_c('div', {
    staticClass: "edit"
  }, [(_vm.haveRecord) ? _c('div', {
    staticClass: "editControlBtns"
  }, [_c('div', {
    attrs: {
      "title": "每行拍子數"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beatPerLine),
      expression: "beatPerLine"
    }],
    attrs: {
      "type": "number",
      "step": "1",
      "min": "0"
    },
    domProps: {
      "value": (_vm.beatPerLine)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beatPerLine = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-level-down",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showGenerateRecordModal()
      }
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "節拍器速度"
    }
  }, [_c('i', {
    staticClass: "fa fa-music",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.playSpeed),
      expression: "playSpeed"
    }],
    attrs: {
      "type": "number",
      "step": "1",
      "min": "0"
    },
    domProps: {
      "value": (_vm.playSpeed)
    },
    on: {
      "change": _vm.changeSpeed,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.playSpeed = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "imgDiv countDownSetting"
  }, [_c('div', {
    staticClass: "editBtns"
  }, [_c('span', [_vm._v("倒數拍數")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getSelectProject.countDownBeats))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addCountDownBeats()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.minusCountDownBeats()
      }
    }
  })])]), _vm._v(" "), _vm._l((_vm.recordImgs), function(recordImgObj, index) {
    return _c('div', {
      key: index,
      staticClass: "imgDiv"
    }, [_c('div', {
      staticClass: "editBtns"
    }, [_c('span', [_vm._v("P" + _vm._s(index + 1))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(recordImgObj.beats))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addBeat(index)
        }
      }
    }), _vm._v(" "), (recordImgObj.beats > 0) ? _c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.minusBeat(index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "controlBtns"
    }, [(index !== 0) ? _c('i', {
      staticClass: "fa fa-arrow-up borderTop",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveRecordBegin(recordImgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== _vm.getSelectProject.record.length - 1) ? _c('i', {
      staticClass: "fa fa-arrow-down borderBottom",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveRecordEnd(recordImgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('i', {
      staticClass: "fa fa-arrow-up",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveRecordUp(recordImgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== _vm.getSelectProject.record.length - 1) ? _c('i', {
      staticClass: "fa fa-arrow-down",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveRecordDown(recordImgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times deleteBtn",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showDeleteRecordModal(recordImgObj.fileName)
        }
      }
    })]), _vm._v(" "), _c('img', {
      attrs: {
        "src": recordImgObj.src
      }
    })])
  }), _vm._v(" "), (_vm.haveRecord) ? _c('div', {
    staticClass: "circleBtn playBtn"
  }, [_c('i', {
    staticClass: "fa fa-play",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.startPlay
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "upload"
  }, [(!_vm.haveImageFile) ? _c('div', {
    staticClass: "uploadDiv"
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("請將樂譜檔案拖曳至此進行上傳")]), _vm._v(" "), _c('input', {
    staticClass: "uploadInput",
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadFile
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "previewImgs"
  }, _vm._l((_vm.projectImgs), function(imgObj, index) {
    return _c('div', {
      key: index,
      staticClass: "imgDiv"
    }, [_c('div', {
      staticClass: "page"
    }, [_c('span', [_vm._v("P" + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "controlBtns"
    }, [(index !== 0) ? _c('i', {
      staticClass: "fa fa-arrow-up borderTop",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveFilBegin(imgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== _vm.projectImgs.length - 1) ? _c('i', {
      staticClass: "fa fa-arrow-down borderBottom",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveFileEnd(imgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('i', {
      staticClass: "fa fa-arrow-up",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveFileUp(imgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== _vm.projectImgs.length - 1) ? _c('i', {
      staticClass: "fa fa-arrow-down",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveFileDown(imgObj.fileName)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times deleteBtn",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showDeleteFileModal(imgObj.fileName)
        }
      }
    })]), _vm._v(" "), _c('img', {
      attrs: {
        "src": imgObj.src
      },
      on: {
        "click": _vm.triggerCutter
      }
    })])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "circleBtn uploadBtn",
    on: {
      "click": _vm.showUploadModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "preview",
      "modalId": "uploadModal"
    }
  }, [_c('div', {
    attrs: {
      "slot": "modalContent"
    },
    slot: "modalContent"
  }, [_c('div', {
    staticClass: "uploadDiv"
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("請將樂譜檔案拖曳至此進行上傳")]), _vm._v(" "), _c('input', {
    staticClass: "uploadInput",
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadFile
    }
  })])])]), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "confirm",
      "modalId": "confirmDeleteModal",
      "title": "確認刪除該頁樂譜?"
    },
    on: {
      "confirm": _vm.deleteFile
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "confirm",
      "modalId": "confirmDeleteRecordModal",
      "title": "確認刪除此筆記錄?"
    },
    on: {
      "confirm": _vm.deleteRecord
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "confirm",
      "modalId": "confirmGenerateRecordModal",
      "title": "確認更新所有頁面節拍數?"
    },
    on: {
      "confirm": _vm.generateRecord
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalTpye": "alert",
      "alertType": "fail",
      "modalId": "uploadFileTypeModal",
      "title": _vm.uploadFileTypeCheckAlert
    }
  }), _vm._v(" "), (_vm.currentStatus === 'play') ? _c('div', {
    staticClass: "play"
  }, [_c('div', {
    staticClass: "progressDiv"
  }, [_c('div', {
    staticClass: "progressBar"
  }, [_c('b-progress', {
    attrs: {
      "max": _vm.playingRecordObj.beats,
      "precision": 1
    },
    model: {
      value: (_vm.playingBeat),
      callback: function($$v) {
        _vm.playingBeat = $$v
      },
      expression: "playingBeat"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "playingContent"
  }, [_c('div', {
    staticClass: "imgDiv countDownDiv",
    class: {
      hide: 0 <= _vm.playingBeat
    }
  }, _vm._l((_vm.getSelectProject.countDownBeats), function(beat, index) {
    return _c('span', {
      key: index,
      staticClass: "countDownAnimate",
      class: {
        active: index < (_vm.playingBeat + _vm.getSelectProject.countDownBeats)
      }
    }, [_vm._v("\n                    " + _vm._s(beat) + "\n                ")])
  }), 0), _vm._v(" "), _vm._l((_vm.recordImgs), function(recordObj, index) {
    return _c('div', {
      key: index,
      staticClass: "imgDiv",
      class: {
        hide: index < _vm.playingPage
      }
    }, [_c('img', {
      attrs: {
        "src": recordObj.src
      }
    })])
  })], 2), _vm._v(" "), (_vm.playingPage > 0) ? _c('div', {
    staticClass: "prevBtn",
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.playingPage < _vm.recordImgs.length - 1) ? _c('div', {
    staticClass: "nextBtn",
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "circleBtn pauseBtn"
  }, [_c('i', {
    staticClass: "fa fa-pause",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.pause.apply(null, arguments)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pageNum"
  }, [_vm._v("\n            " + _vm._s(_vm.playingPage + 1) + " / " + _vm._s(_vm.recordImgs.length) + "\n        ")]), _vm._v(" "), (_vm.playStatus === 'pause') ? _c('div', {
    staticClass: "pauseScreen"
  }, [(_vm.playingPage > 0) ? _c('div', {
    staticClass: "prevBtn",
    on: {
      "click": function($event) {
        return _vm.prevPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.playingPage < _vm.recordImgs.length - 1) ? _c('div', {
    staticClass: "nextBtn",
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [(_vm.playingBeat !== _vm.playingRecordObj.beats) ? _c('div', {
    staticClass: "circleBtn playBtn"
  }, [_c('i', {
    staticClass: "fa fa-play",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.keepPlay
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "circleBtn repeatBtn"
  }, [_c('i', {
    staticClass: "fa fa-repeat",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reply.apply(null, arguments)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "circleBtn stopBtn"
  }, [_c('i', {
    staticClass: "fa fa-stop",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stop.apply(null, arguments)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "circleBtn toListBtn",
    on: {
      "click": _vm.toListPage
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9ee2ad2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-project.vue
// module id = 198
// module chunks = 2